var FIGURE = FIGURE || {};

FIGURE.shippingMessage = function() {
	var specialMessageModal = $.cookie('specialmessage');
	if (specialMessageModal == 'read') {
		return;
	} else {
		setTimeout(function(){
			$('#figureMessageModal').modal();
		}, 3000);	
	}	
	$('#figureMessageModal').on('hide.bs.modal', function (event) {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
	$('#figureMessageModal a').click(function() {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
}();

FIGURE.fader = function() {
	$('.page-pages-wine').addClass('darkness');
	setTimeout(function(){
		$('.page-pages-wine').addClass('loaded');	
	}, 500);	
	// $(window).scroll(function(event){
	// 	if ($('.dark').is(':in-viewport')) {
	// 		$('body').addClass('darkness');
	// 	} else {
	// 		$('body').removeClass('darkness');
	// 	}
	// });
	$(window).on('scroll resize', function() {
		if ($('.dark-trigger-js').length) {
			const windowHeight = window.innerHeight;
			const divTop = $('.dark-trigger-js')[0].getBoundingClientRect().top;
			const divPosition = divTop / windowHeight * 100;
			if (divPosition >= 50) {
				$('body').addClass('darkness');
			} else {
				$('body').removeClass('darkness');
			}
		}
	})
}();